var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCasaBranco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666687 17.25V6.25L8.04585 0.75L15.3334 6.25V17.25H9.97085V10.7188H6.00627V17.25H0.666687ZM2.04169 15.875H4.63127V9.34375H11.3459V15.875H13.9584V6.9375L8.04585 2.46875L2.04169 6.9375V15.875Z",
    fill: "#FFFFFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasaBranco);
export default __webpack_public_path__ + "static/media/casaBranco.deb93ac85332de271f76d1f8a0e079ca.svg";
export { ForwardRef as ReactComponent };